import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios"
import { AuthHeaders, CasesearchQueryLog } from "../stores/store_types"
import axios from "./index"

// APIを呼び出して事例検索クエリログを取得
const callCasesearchQueryLogAPI = (
  headers: AuthHeaders,
  parameter: { corporationId: number; targetMonth: Date },
  successCallback: (
    headers: AxiosResponseHeaders,
    casesearchQueryLogs: Array<CasesearchQueryLog>
  ) => void,
  failureCallback: () => void
) => {
  axios
    .get("/api/v1/casesearch_query_logs", {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString(),
      },
    })
    .then((response: AxiosResponse) => {
      successCallback(response.headers, response.data["logs"])
    })
    .catch((error: AxiosError) => {
      console.error(error)
      failureCallback()
    })
}

// APIを呼び出して事例検索クエリログをCSV形式でダウンロード
const callDownloadCasesearchQueryLogAPI = (
  headers: AuthHeaders,
  parameter: { corporationId: number; targetMonth: Date },
  successCallback: (headers: AxiosResponseHeaders, blob: Blob) => void,
  failureCallback: () => void
) => {
  axios
    .get("/api/v1/casesearch_query_logs.csv", {
      headers: headers,
      responseType: "blob",
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString(),
      },
    })
    .then((response: AxiosResponse) => {
      const mineType = response.headers["content-type"]
      const blob = new Blob([response.data], { type: mineType })
      successCallback(response.headers, blob)
    })
    .catch((error: AxiosError) => {
      console.error(error)
      failureCallback()
    })
}

export { callCasesearchQueryLogAPI, callDownloadCasesearchQueryLogAPI }
